import { PerformanceEvent } from '../../../models/performance-event.model';
import { PastDispatchTableRow, RegistrationTableRow } from '../../../models/performance-view.model';

export function toRegistrationTableRow(event: PerformanceEvent): RegistrationTableRow {
  return {
    id: event.eventId,
    site: event.siteName,
    organizationId: event.organizationId,
    organization: event.organizationName,
	registrationLabel: '',
    eventDate: event.eventStartDttm,
    enrolled: event.enrollmentValue,
    delivered: event.performanceValue,
    performance: event.performancePercentage,
    dataQuality: event.perfGoodDq ? 'Final' : 'Preliminary',
  };
}

export function toPastDispatchTableRow(event: PerformanceEvent): PastDispatchTableRow {
  return {
    id: event.eventId,
    productId: event.productId,
    siteId: event.siteId,
    portfolio: '', 
    product: '', 
	organization: event.organizationName,
    program: event.programName,
    site: event.siteName,
    eventStartDateUtc: event.eventStartDttm,
    eventEndDateUtc: event.eventEndDttm,
    enrolled: event.enrollmentValue,
    delivered: event.performanceValue,
    performance: event.performancePercentage,
    dataQuality: event.perfGoodDq ? 'Final' : 'Preliminary',
  };
}

export function productPerformanceEventToPastDispatchTableRow(event: PerformanceEvent): PastDispatchTableRow {
  return {
    id: event.eventId,
    productId: event.productId,
    siteId: event.siteId,
    portfolio: '',
    product: '',
    organization: '',
    program: event.programName,
    site: event.siteName,
    eventStartDateUtc: event.eventStartDttm,
    eventEndDateUtc: event.eventEndDttm,
    enrolled: event.enrollmentValue,
    delivered: event.performanceValue,
    performance: event.performancePercentage,
    dataQuality: event.perfGoodDq ? 'Final' : 'Preliminary',
  };
}
